<template>
  <v-card class="py-2">
    <v-row no-gutters align="center" class="py-1 justify-start">
      <v-col cols="auto" class="pl-5">
        <v-icon color="error">
          mdi-alert-box
        </v-icon>
      </v-col>
      <v-col cols="auto" class="documentName" style="max-width: 60%">
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <div v-on="on" class="text-truncate" style="max-width: 17vw">
              {{ item.titleText }}
            </div>
          </template>
          {{ item.titleText }}
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters class="py-2">
      <v-col cols="auto" class="text-left pl-5 pr-2 idText"> {{ $i18n.t('menu.assignedLantern') }}</v-col>
      <v-col cols="auto" class="font-weight-medium">
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <div v-on="on" class="text-truncate folderInfo" style="max-width: 13vw">
              {{ item.lantern_id ? item.lantern_id : $i18n.t('default.missing') }}
            </div>
          </template>
          {{ item.lantern_id ? item.lantern_id : '' }}
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters class="py-2">
      <v-col cols="auto" class="text-left pl-5 pr-2 idText"> {{ $i18n.t('menu.street') }}</v-col>
      <v-col cols="auto" class="font-weight-medium">
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <div v-on="on" class="text-truncate folderInfo" style="max-width: 15vw">
              {{ item.street_name ? item.street_name : $i18n.t('default.missing') }}
            </div>
          </template>
          {{ item.street_name ? item.street_name : '' }}
        </v-tooltip>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'FailurePreview',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.idText {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}
.folderInfo {
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
}
.documentName {
  font-weight: 500;
  font-size: 14px;
  padding-left: 8px;
  text-align: left;
}
</style>
